import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin-top: 2rem;
  @media (min-width: 800px) {
    padding: 0 3.8rem;
  }
`;
